import "./AboutBusinessTantra.module.css";
import Header from "@/reusable_sections/Header";
import TheRsvpLegacy from "./sections/TheRsvpLegacy";
import OurGuidingPrinciples from "./sections/OurGuidingPrinciples";
import Footer from "@/reusable_sections/Footer";
export default function AboutBusinessTantraPage() {
  return <div>
      <Header />
      <TheRsvpLegacy />
      <OurGuidingPrinciples />
      <Footer />
    </div>;
}